import type { CSSProperties } from 'react';

// Properties React writes as bare numbers (React 19's list); every other numeric value gets `px`.
const UNITLESS = new Set(
  (
    'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup ' +
    'boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea ' +
    'gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart ' +
    'fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity ' +
    'floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth'
  ).split(' ')
);

/**
 * `style` as React would write it to the DOM, for an element React does not render (a batched math field):
 * a numeric length such as `height: 40` becomes `40px`, which assigning it to `element.style` would drop.
 */
export function toDomStyle(style: CSSProperties): Record<string, string> {
  return Object.fromEntries(
    Object.entries(style)
      .filter(([, value]) => value !== undefined && value !== null && value !== false)
      .map(([name, value]) => [
        name,
        typeof value === 'number' && value !== 0 && !UNITLESS.has(name) && !name.startsWith('--')
          ? `${value}px`
          : String(value)
      ])
  );
}
